<template>
  <div v-loading="loading" class="columnsconfig">
    <h2 class="config-title">{{ $t("portfolio-configuration") }}</h2>
    <div class="mt-1" style="font-size:13px">{{ $t("select-data-to-use-in-table-vis") }}</div>
    <div class="config-save-search-container mt-1 mb-1">
      <div class="input-search">
        <textInput v-model="filterColumns" placeholder="Search" icon="search" class="brains-type1-number-input" />
      </div>
      <button class="brains-type1-btn pf-cnf-btn-right" @click="saveportconfig()">{{ $t("saveComponent.save") }}</button>
    </div>
    <div class="columnsselector mt-2">
      <div class="columns-config-header">
        <div class="columns-config-header--first">{{ $t("column-name") }}</div>
        <div class="columns-config-header--second">{{ $t("View in table") }}<div class="ml-1"><checkBox v-model="checkAll" :input-value="false" /></div></div>
      </div>
      <draggable
        v-model="filteredFields"
        class="columns-config-dnd"
        tag="ul"
        v-bind="dragOptions"
        @start="drag = true"
        @end="drag = false"
      >
        <transition-group type="transition" :name="!drag ? 'flip-list' : null" tag="ul">
          <!--<ul>-->
          <li v-for="item in filteredFields" :key="item" class="columns-config-row" :class="{'columns-config-row--checked' : item.useintable}">
            <div class="columns-config-row--first"><font-awesome-icon class="columns-config-row--arrow" icon="arrows-alt-v" />{{ item.label }}</div>
            <div class="columns-config-chcbx"><checkBox v-model="item.useintable" :input-value="false" /></div>
          </li>
          <!--</ul>-->
        </transition-group>
      </draggable>
    </div>
  </div>
</template>

<script>
import textInput from '@/components/designComponents/textInput'
import checkBox from '@/components/designComponents/checkBox'
import draggable from 'vuedraggable'
import { mapState } from 'vuex'
export default {
  name: 'PortfolioColumnsConfig',
  components: {
    textInput,
    checkBox,
    draggable
  },
  props: {
    portfolioid: {
      default: null
    }
  },
  data() {
    return {
      tableKey: 1,
      fields: [],
      loading: false,
      filterColumns: '',
      checkAll: false,
      drag: false
    }
  },
  computed: {
    ...mapState('portfolio', {
      listcolumnsport: (state) => state.currentportfolio.tableColumns,
      portfolioOrderedFields: (state) => state.portfolioOrderedFields
    }),
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    filteredFields: {
      get() {
        var previousFiltered = this.portfolioOrderedFields
        if (previousFiltered.length > 0) {
          return previousFiltered.filter((item) => {
            return item.prop.includes(this.filterColumns)
          })
        }
        return this.fields.filter((item) => {
          return item.prop.includes(this.filterColumns)
        })
      },
      set(value) {
        this.fields = value
        this.$store.dispatch('portfolio/setOrderedFields', { value: value })
      }
    }
  },
  watch: {
    checkAll(newOne) {
      this.filteredFields.forEach(item => {
        item.useintable = newOne
      })
    }
  },
  methods: {
    gotoportfolio() {
      const vm = this
      vm.loading = true
      vm.$store.dispatch('portfolio/loadportfolio', vm.portfolioid)
        .then(() => {
          vm.loading = false
        })
        .catch(() => {
          vm.$message({
            showClose: true,
            message: this.$t('portfoliosSelector.errorloadingportfoliodata'),
            type: 'error'
          })
          vm.loading = false
        })
    },
    loadtable(data) {
      this.fields = data
      this.setActualColumns()
    },
    setActualColumns() {
      this.fields.forEach((field) => {
        this.listcolumnsport.forEach((column) => {
          if (field.prop === column.brainsId) {
            field.useintable = true
          }
        })
      })
    },
    saveportconfig() {
      const vm = this
      vm.loading = true
      const data = {
        id: vm.portfolioid,
        tablecolumns: vm.fields.filter((item) => {
          return item.useintable === true
        }),
        type: 'list'
      }
      vm.$store.dispatch('portfolio/saveportfolioconfig', data)
        .then((response) => {
          vm.gotoportfolio()
        })
        .catch(() => {
          vm.$message({
            showClose: true,
            message: this.$t('portfoliosSelector.errorsavingconfig'),
            type: 'error'
          })
          vm.loading = false
        })
    }
  }
}
</script>

<style lang="scss">
.columnsconfig {
  .sortable-chosen {
    background-color: lightgrey;
  }
}
</style>

<style lang="scss" scoped>
.columns-config-header {
  display: grid;
  border-bottom: 2px solid #1e3cff;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  grid-template-columns: 70% 30%;
  font-family: 'Montserrat-SemiBold',sans-serif;
  font-size: 14px;

  &--first {
    padding: 6px 0;
  }

  &--second {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.columns-config-dnd {
  font-size: 13px;

  .columns-config-row--checked {
    background-color: #1e3cff98;
  }

  .columns-config-row {
    position: relative;
    cursor: grab;
    font-family: 'Montserrat-Light',sans-serif;
    display: grid;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    grid-template-columns: 70% 30%;
    border-bottom: 1px solid #c2c2c2;

    &--first {
      padding: 7px 0;
    }

    &--arrow {
      position: absolute;
      left: 20px;
      color: grey;
    }

    .columns-config-chcbx {
      padding: 6px 0;
    }
  }
}
.pf-cnf-btn-right {
  margin-left: auto;
  margin-right: 0;
}

.columnsconfig {
  padding: 25px 20px 25px 20px;
  width: 500px;

  .config-title {
    font-size: 20px;
    font-family: "Montserrat-SemiBold",sans-serif;
  }

  .config-save-search-container {
    display: flex;
    height: 30px;
    justify-content: center;
    align-items: center;

  }

  .columnsselector {
    height: 40vh;
    overflow: scroll;
    width: 100%;
  }
}

.col-check-all-config {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>
